export default __webpack_public_path__ + "static/media/ringtone.45f50bad.mp3";